module.exports = __webpack_public_path__ + "static/media/bootstrap.38eea579.png";